import React from 'react';
import { Box, Typography } from '@mui/material';

const Header: React.FC = () => {
  return (
    <Box sx={{ textAlign: 'center' }}>
      <Typography variant="h3" component="h3" gutterBottom>
        Escolha o plano ideal para você
      </Typography>
    </Box>
  );
};

export default Header;